import { useUpdateArtist } from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';
import { ArtistContractingPartyFormSchemaType } from '../useArtistContractingPartyForm';

const TRANS_KEY = 'NOTIFICATIONS.UPDATE_ARTIST';

type UseUpdateArtistContractingPartyReturnType = {
  submitUpdateArtistContractingParty: (
    data: ArtistContractingPartyFormSchemaType
  ) => Promise<void>;
};

export const useUpdateArtistContractingParty = (
  artistId: string
): UseUpdateArtistContractingPartyReturnType => {
  const { mutateAsync: updateArtist } = useUpdateArtist();
  const { showSuccess, showError } = useNotification();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error,
    });
  };

  const submitUpdateArtistContractingParty = async (
    data: ArtistContractingPartyFormSchemaType
  ): Promise<void> => {
    await updateArtist(
      {
        artistId,
        data: {
          contractingPartyPersons: data.contractingPartyPersons,
          contractingPartyCompanies: data.contractingPartyCompanies,
        },
      },
      { onSuccess, onError }
    );
  };

  return { submitUpdateArtistContractingParty };
};
